import {Palette} from 'hubbl-shared';
import {AssetIconProps} from '../types';
import {memo} from 'react';

export const AssetIconAI = memo(
  ({size = 24, color = Palette.almostBlack}: AssetIconProps) => {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path
          d="M10.1211 3.12029C10.2437 2.75784 10.7563 2.75784 10.8789 3.12029L12.7892 8.76817C13.0789 9.62466 13.7394 10.3048 14.587 10.6195L19.9898 12.625C20.3375 12.7541 20.3375 13.2459 19.9898 13.375L14.587 15.3805C13.7394 15.6952 13.0789 16.3753 12.7892 17.2318L10.8789 22.8797C10.7563 23.2422 10.2437 23.2422 10.1211 22.8797L8.21082 17.2318C7.92113 16.3753 7.26061 15.6952 6.41298 15.3805L1.01021 13.375C0.662481 13.2459 0.66248 12.7541 1.01021 12.625L6.41298 10.6195C7.26061 10.3048 7.92113 9.62466 8.21082 8.76817L10.1211 3.12029Z"
          fill={color}
        />
        <path
          d="M19.298 0.569977C19.3655 0.379706 19.6345 0.379706 19.702 0.569977L20.5068 2.84125C20.6147 3.14578 20.8542 3.38535 21.1588 3.49325L23.43 4.29804C23.6203 4.36546 23.6203 4.63454 23.43 4.70196L21.1588 5.50675C20.8542 5.61465 20.6147 5.85422 20.5068 6.15875L19.702 8.43002C19.6345 8.62029 19.3655 8.62029 19.298 8.43002L18.4933 6.15875C18.3853 5.85422 18.1458 5.61465 17.8412 5.50675L15.57 4.70196C15.3797 4.63454 15.3797 4.36546 15.57 4.29804L17.8412 3.49325C18.1458 3.38535 18.3853 3.14578 18.4932 2.84125L19.298 0.569977Z"
          fill={color}
        />
      </svg>
    );
  },
);
